/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */


import {SkeletonSettings} from "../utils/SkeletonSettings";
import ContentLoader from "react-content-loader";
import React from "react";

export const RecipeListButtonSkeleton = (props) => (
    <ContentLoader
        height={60}
        width={"100%"}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        {...props}>

        {/* Button */}
        <rect x="0" y="0" rx="3" ry="3" width="50%" height="40"/>

    </ContentLoader>
)
